const ApprovedIcon = ({ color }: any) => {
  return (
    <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.8337 6.96407V7.50074C12.8329 8.75865 12.4256 9.98263 11.6724 10.9901C10.9193 11.9976 9.86057 12.7347 8.65428 13.0913C7.44799 13.448 6.15873 13.4052 4.97877 12.9692C3.79881 12.5333 2.79137 11.7276 2.10672 10.6724C1.42206 9.61709 1.09687 8.36877 1.17964 7.11359C1.2624 5.8584 1.7487 4.66359 2.56599 3.70736C3.38328 2.75113 4.48778 2.08471 5.71477 1.80749C6.94175 1.53027 8.22548 1.6571 9.3745 2.16907'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.8333 2.83398L7 8.67315L5.25 6.92315'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default ApprovedIcon
